import React from 'react';
import './FooterBadge.css';

const FooterBadge = ({title, children}) => {
  return (
    <div className='footerBadge'>
      <div>
        {children}
      </div>
      <div>
       {title}
      </div>
    </div>
  );
};

export default FooterBadge;